export const dataverseUrl = import.meta.env.VITE_DATAVERSE_URL ?? "";
export const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID ?? "";
export const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID ?? "";
export const redirectUri = import.meta.env.VITE_ENTRA_REDIRECT_URI || window.location.origin;
export const msalConfig = {
    auth: {
        clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri,
        postLogoutRedirectUri: redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};
export const loginScopes = ["User.Read", "User.ReadBasic.All"];
export const dataverseScopes = dataverseUrl
    ? [`${dataverseUrl}/user_impersonation`]
    : [];
